import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Image } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import "../App.css"; // Import your CSS styles

function Crousel() {
  return (
    <div>
      <div className="video-container" style={{ backgroundColor: "#000" }}>
        <video
          className="background-video"
          autoPlay
          loop
          muted
          playsInline
          src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737877317GIFSOI.mp4"
          type="video/mp4"
        ></video>
        {/* Overlay Navbar */}
        <Navbar expand="lg" className="navbar-overlay px-3">
          <div className="container-fluid">
            {/* Left-aligned logo */}
            <Navbar.Brand href="https://www.jindalsteel.com/" className="me-auto">
              <Image src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737812920jindal-logowhite.png" alt="jspl" width={150} />
            </Navbar.Brand>

            {/* Right-aligned menu */}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          </div>
        </Navbar>
      </div>
    </div>
  );
}

export default Crousel;
